const OPEN_GENERATE_SECOND_SECRET_WIZARD = 'OPEN_GENERATE_SECOND_SECRET_WIZARD';
const CLOSE_GENERATE_SECOND_SECRET_WIZARD = 'CLOSE_GENERATE_SECOND_SECRET_WIZARD';
const NEXT_STEP_GENERATE_SECOND_SECRET = 'NEXT_STEP_GENERATE_SECOND_SECRET';

export { OPEN_GENERATE_SECOND_SECRET_WIZARD, CLOSE_GENERATE_SECOND_SECRET_WIZARD, NEXT_STEP_GENERATE_SECOND_SECRET };
